﻿import { truckTypesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("truck-type"),
  endpoint: "truck-types",
  operations: truckTypesOps,
  roleView: [ROLE.TRUCK_VIEW, ROLE.TRUCK_ADMIN],
  roleAdmin: [ROLE.TRUCK_ADMIN],
  singularName: (t) => t("Truck type"),
  name: (t) => t("Truck types"),
  syncCustomerFilter: true,
});
export default conf;
